export const GET_SCHOOL_INFO = "GET_SCHOOL_INFO"
export const GET_SCHOOL_INFO_SUCCESS = "GET_SCHOOL_INFO_SUCCESS"
export const GET_SCHOOL_INFO_FAILED = "GET_SCHOOL_INFO_FAILED"